import ProductStrip, { type ProductStripCta } from '_components/ProductStrip';
import type { AlgonomyPlacement } from '@components/global/Recommendations/Loader';
import { useLocale } from '@hooks/useLocale';
import { localizeHref } from '@utils/localizeHref';

export interface AlgonomyPlacementCarouselProps {
  placement?: AlgonomyPlacement;
  coOpBrand?: string | null;
  ctaLabel?: string | null;
  ctaUrl?: string | null;
}

// coOpBrand is accepted via AlgonomyPlacementCarouselProps, ready for the
// follow-up GA4 ticket — it is not yet used in any tracking call.
const AlgonomyPlacementCarousel = ({
  placement,
  ctaLabel,
  ctaUrl,
}: AlgonomyPlacementCarouselProps) => {
  const locale = useLocale();

  if (!placement) return null;

  const label = ctaLabel?.trim();
  const url = ctaUrl?.trim();
  const cta: ProductStripCta | undefined =
    label && url ? { label, href: localizeHref(url, locale) } : undefined;

  // Only ever rendered inside a CIP/CLP slice zone, which owns the spacing
  // between slices and sets the side gutters every other slice uses.
  return <ProductStrip placement={placement} inSliceZone cta={cta} />;
};

export default AlgonomyPlacementCarousel;
